"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var CombinationChartViewComponent_1;
const idm_export_client_js_1 = require("@synisys/idm-export-client-js");
const core_1 = require("@angular/core");
const Observable_1 = require("rxjs/Observable");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
const idm_page_service_client_js_1 = require("@synisys/idm-page-service-client-js");
const skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
const store_1 = require("@ngrx/store");
const operators_1 = require("rxjs/operators");
const idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
const idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
const combination_chart_builder_component_1 = require("../builder/combination-chart-builder.component");
const shared_1 = require("../../../../controls/chart/shared");
const chart_sort_type_model_1 = require("../../categorical-chart/shared/chart-sort-type.model");
const reporting_controls_common_logic_1 = require("../../../shared/reporting-controls-common-logic");
const chart_table_data_1 = require("../../shared/model/chart-table-data");
const multilingual_type_helper_1 = require("../../../../shared/multilingual-type-helper");
const color_palette_service_1 = require("../../shared/service/color-palette.service");
const export_data_proccessing_service_1 = require("../../../../controls/export/export-data-proccessing-service");
const page_filter_service_1 = require("../../../page-filter/service/page-filter.service");
const path_processing_helper_1 = require("../../../../shared/path-processing-helper");
const data_formatter_1 = require("../../../list/helper/data-formatter");
const combination_chart_model_1 = require("../model/combination-chart.model");
const sis_radar_chart_control_component_1 = require("../../../../controls/chart/radar-chart/sis-radar-chart-control.component");
const idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
const idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
const router_1 = require("@angular/router");
let CombinationChartViewComponent = CombinationChartViewComponent_1 = 
/**
 * This component creates Combination Charts according to passed parameters.
 */
class CombinationChartViewComponent extends reporting_controls_common_logic_1.ReportingControlsCommonLogic {
    constructor(_languageService, _currentLanguageProvider, _reportingService, _pathService, _colorPaletteService, _categoryPathService, _exportService, exportDataService, _pageNavigationService, store, messageService, classifierService, kbService, _activatedRoute, communicationService, pageFilterService) {
        super(_activatedRoute, communicationService, pageFilterService);
        this._languageService = _languageService;
        this._currentLanguageProvider = _currentLanguageProvider;
        this._reportingService = _reportingService;
        this._pathService = _pathService;
        this._colorPaletteService = _colorPaletteService;
        this._categoryPathService = _categoryPathService;
        this._exportService = _exportService;
        this.exportDataService = exportDataService;
        this._pageNavigationService = _pageNavigationService;
        this.store = store;
        this.messageService = messageService;
        this.classifierService = classifierService;
        this.kbService = kbService;
        this.chartTableData = null;
        /**
         * These property stored current report view image, which be needed in export
         */
        this.exportImages = new Map();
        this.pageNavigationItems = [];
        this.isCardTitleLongerThenToolbarSection = false;
    }
    /**
     * This property stores control title string.
     */
    set title(title) {
        this.reportTitle = multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(title);
    }
    ngOnChanges(changes) {
        if (changes['state'] || changes['entity'] || changes['filters']) {
            this.chartData = null;
            this._languageService.getAvailableLanguages()
                .pipe(operators_1.takeUntil(this.destroy$))
                .subscribe((languages) => {
                this.languages = languages;
                if (changes['state']) {
                    !this.chartModel && (this.chartModel = new combination_chart_model_1.CombinationChartModel());
                    this.chartModel.fromJson(this.state);
                }
                this.selectedCategoryId = this.chartModel.category;
                this.selectedSeriesId = this.chartModel.series;
                // redraw chart is called when page filters will be ready
                this.redrawWithSubscribeToPageFilterChange();
            });
        }
    }
    ngOnInit() {
        (this.id === '' || this.id === undefined) && (this.id = "combination_chart");
    }
    ngAfterViewInit() {
        if (this.rcChartBarToolbarSection && this.rcChartBarToolbarTitle) {
            let toolbarTitleMarginRight = 16;
            this.isCardTitleLongerThenToolbarSection = this.rcChartBarToolbarSection.nativeElement.offsetWidth === this.rcChartBarToolbarTitle.nativeElement.offsetWidth + toolbarTitleMarginRight;
        }
    }
    buildExportReport(exportType) {
        this.getExportData(exportType)
            .then((exportData) => {
            this._exportService.exportWithData(exportData)
                .pipe(operators_1.takeUntil(this.destroy$))
                .subscribe();
        });
    }
    getExportDto(type, orientation) {
        return this.getExportData(type)
            .then((exportData) => {
            return {
                url: null,
                serviceKey: export_data_proccessing_service_1.ExportDataProcessingService.EXPORT_SERVICE_URL_KEY,
                serviceContext: export_data_proccessing_service_1.ExportDataProcessingService.EXPORT_SERVICE_ENDPOINT,
                method: export_data_proccessing_service_1.ExportDataProcessingService.EXPORT_SERVICE_METHOD,
                cardTitle: this.widgetTitle,
                headers: new Map(),
                contentType: export_data_proccessing_service_1.ExportDataProcessingService.EXPORT_SERVICE_CONTENT_TYPE,
                body: exportData,
                params: new Map()
            };
        });
    }
    createChartReport() {
        let sortingType = this.chartModel.chartSortType;
        let reportBuilder = new idm_reporting_service_client_js_1.ReportDtoBuilder();
        // If selected sorting is on category apply sorting on category
        let categorySortingType = (sortingType === chart_sort_type_model_1.ChartSortType.CATEGORY_ASCENDING || sortingType === chart_sort_type_model_1.ChartSortType.TIME) ?
            idm_reporting_service_client_js_1.OrderType.ASCENDING : (sortingType === chart_sort_type_model_1.ChartSortType.CATEGORY_DESCENDING ? idm_reporting_service_client_js_1.OrderType.DESCENDING : null);
        let rowCategoryBuilder = reportBuilder.addRowCategory(this.selectedCategoryId);
        (sortingType !== chart_sort_type_model_1.ChartSortType.TIME) && rowCategoryBuilder.setTopCount(this.chartModel.categoriesTop);
        categorySortingType !== null && rowCategoryBuilder.setOrderType(categorySortingType);
        this.selectedSeriesId && rowCategoryBuilder.addRowCategory(this.selectedSeriesId).setTopCount(this.chartModel.seriesTop);
        let valuesSortingType = sortingType === chart_sort_type_model_1.ChartSortType.VALUES_ASCENDING ?
            idm_reporting_service_client_js_1.OrderType.ASCENDING : sortingType === chart_sort_type_model_1.ChartSortType.VALUES_DESCENDING ? idm_reporting_service_client_js_1.OrderType.DESCENDING : null;
        const measures = this.chartModel.columnMeasures.concat(this.chartModel.lineMeasures);
        measures.forEach((measure) => {
            let measureBuilder = reportBuilder.addColumnMeasure(measure.id);
            // If selected sorting is on measure, apply sorting on all measure fields
            if (valuesSortingType !== null) {
                measureBuilder.setOrderType(valuesSortingType);
            }
            if (measure.currencyId) {
                measureBuilder.setCurrencyId(measure.currencyId);
            }
        });
        return reportBuilder.build();
    }
    /**
     * Adds filters and executes report based on data and filters.
     * Filters' structure is [{"systemName": "Project", "items": [1,2,3]}]
     * In case filter contains root category's systemName it is filtered ONLY by root category, else OR filter is used.
     * */
    executeChartReport() {
        let report = this.createChartReport();
        let entityId = this.entity && this.entity.getInstanceId();
        this.allFiltersTreeDto = this.chartModel.filter || new idm_reporting_service_client_js_1.FilterTreeDto();
        this.pageFilterTreeDto && (this.allFiltersTreeDto = idm_reporting_service_client_js_1.FilterDtoBuilder.combineAnd(this.allFiltersTreeDto, this.pageFilterTreeDto));
        (this.filters || entityId) && (this.allFiltersTreeDto = this.updateFilters(this.filters, this.allFiltersTreeDto, this.category, entityId, this.rootPath));
        let reportOptions = this.buildReportOptions();
        let pagingCriteria = idm_reporting_service_client_js_1.PagingCriteria.all();
        this.reportingError = false;
        Observable_1.Observable.from(this._reportingService.executeReport(report, this.allFiltersTreeDto, this.currentLanguageId, this.dataSetId, reportOptions, pagingCriteria))
            .pipe(operators_1.takeUntil(this.destroy$), operators_1.catchError(() => this.reportingErrorHandler()))
            .subscribe((reportData) => {
            const categoryPath = this.categoryMeasurePaths.categoryPaths.get(this.selectedCategoryId);
            const reportTable = reportData.tables[0];
            let hasTimelineGap = false;
            let reportCategories = [];
            if (reportTable) {
                reportCategories = reportTable.rowGrouping.filter(row => row.rowCategories[0].id);
                reportCategories.length > 1 && (hasTimelineGap = true);
            }
            if (categoryPath.categoryType === idm_dataset_service_client_js_1.CategoryType.DATE && hasTimelineGap) {
                this.kbService.getIdentityMetaField(categoryPath.metaCategoryId.systemName, 'reporting')
                    .pipe(operators_1.takeUntil(this.destroy$), operators_1.switchMap((metaField) => {
                    const startId = reportCategories[0].rowCategories[0].id;
                    const endId = reportCategories[reportCategories.length - 1].rowCategories[0].id;
                    const filter = new idm_classifier_service_client_js_1.FilterBuilder().range(metaField.getSystemName(), startId, endId).buildJson();
                    return this.classifierService.loadClassifiersViewByFilter(categoryPath.metaCategoryId.systemName, filter);
                }))
                    .subscribe((classifiers) => {
                    this.initChartView(reportData, classifiers);
                });
            }
            else {
                this.initChartView(reportData, []);
            }
        });
    }
    initChartView(reportData, classifiers) {
        this.processChartOptions(this.currentLanguage.getDirection());
        this.chartData = this.processChartData(reportData, classifiers);
        const isDataInValid = !this.chartData.series || this.chartData.series.length === 0 ||
            this.chartData.data.length === 0;
        if (isDataInValid) {
            this.validationMessage = reporting_controls_common_logic_1.ReportingControlsCommonLogic.NO_DATA_MESSAGE;
            this.isValid = false;
        }
        else {
            this.hasData = true;
            this.processChartTableData();
            this.sendWidgetExportData();
        }
    }
    /**
     * Process received data convenient with amChart
     * @protected
     * @param reportData
     * @param classifiers
     * @returns {any}
     */
    processChartData(reportData, classifiers) {
        let chartReportData = reportData.tables[0];
        let processedChartData = {};
        processedChartData.drillDownPages = this.chartModel.pages ? path_processing_helper_1.processPageItems(this.chartModel.pages.slice(), this.pageNavigationItems, this.currentLanguageId) : [];
        if (chartReportData !== undefined) {
            //Getting report categories
            let categoryElements = new Map();
            if (classifiers.length) {
                classifiers.forEach((classifier) => {
                    !categoryElements.get(classifier.id) && categoryElements.set(classifier.id, classifier.name);
                });
            }
            else {
                chartReportData.rowGrouping.map((dataItem) => {
                    let categoryItem = dataItem.rowCategories[0];
                    !categoryElements.get(categoryItem.id) && categoryElements.set(categoryItem.id, categoryItem.name);
                });
            }
            processedChartData.categories = Array.from(categoryElements.values());
            processedChartData.categoriesMap = categoryElements;
            processedChartData.series = [];
            if (this.chartModel.series) {
                //Processing series, if report had selected series
                let seriesElements = new Map();
                chartReportData.rowGrouping.map((dataItem1) => {
                    let seriesData = dataItem1.rowCategories[1];
                    if (!seriesElements.get(seriesData.id)) {
                        chartReportData.rowGrouping.map((dataItem2) => {
                            let seriesElement = dataItem2.rowCategories[1];
                            let categoryElement = dataItem2.rowCategories[0];
                            if (seriesData.id === seriesElement.id) {
                                if (!seriesElements.get(seriesData.id)) {
                                    seriesElements.set(seriesData.id, new Map([[categoryElement.id, dataItem2.values]]));
                                }
                                else {
                                    seriesElements.get(seriesData.id).set(categoryElement.id, dataItem2.values);
                                }
                            }
                            else {
                                if (!seriesElements.get(seriesData.id)) {
                                    seriesElements.set(seriesData.id, new Map([[categoryElement.id, [null, null]]]));
                                }
                                else {
                                    !seriesElements.get(seriesData.id).get(categoryElement.id) && seriesElements.get(seriesData.id).set(categoryElement.id, [null, null]);
                                }
                            }
                        });
                        let seriesItem = {};
                        seriesItem.name = seriesData.name;
                        seriesItem.data = this.matchSeriesWithCategories(categoryElements, seriesElements.get(seriesData.id));
                        seriesItem.seriesId = seriesData.id;
                        processedChartData.series.push(seriesItem);
                    }
                });
            }
            else {
                const measures = this.chartModel.columnMeasures.concat(this.chartModel.lineMeasures);
                let seriesData = reportData.tables[0].columnGrouping.values;
                seriesData.forEach((el, index) => {
                    let seriesItem = {};
                    seriesItem.name = el.name;
                    seriesItem.data = [];
                    let measure = measures[index];
                    seriesItem.symbol = measure.currencyId ? this.currencies.find((currency) => currency.id === measure.currencyId).symbol : '';
                    seriesItem.currencyId = measure.currencyId;
                    seriesItem.measureId = measure.id;
                    if (classifiers.length) {
                        classifiers.forEach((classifier) => {
                            const rowData = chartReportData.rowGrouping.find(row => row.rowCategories[0].id === classifier.id);
                            seriesItem.data.push({
                                categoryId: classifier.id,
                                value: rowData ? rowData.values[index] : null
                            });
                        });
                    }
                    else {
                        chartReportData.rowGrouping.map((dataItem) => {
                            seriesItem.data.push({
                                categoryId: dataItem.rowCategories[0].id,
                                value: dataItem.values[index]
                            });
                        });
                    }
                    processedChartData.series.push(seriesItem);
                });
            }
            processedChartData.data = [];
            processedChartData.columnMeasures = this.chartModel.columnMeasures.map(measure => {
                return {
                    id: measure.id,
                    name: this.categoryMeasurePaths.measurePaths.get(+measure.id).name.get(this.currentLanguageId)
                };
            });
            processedChartData.lineMeasures = this.chartModel.lineMeasures.map(measure => {
                return {
                    id: measure.id,
                    name: this.categoryMeasurePaths.measurePaths.get(+measure.id).name.get(this.currentLanguageId)
                };
            });
            if (this.chartModel.series) {
                processedChartData.seriesItems = [];
                const columnMeasureItem = this.chartModel.columnMeasures[0];
                const columnMeasureName = columnMeasureItem ? this.categoryMeasurePaths.measurePaths.get(+columnMeasureItem.id).name.get(this.currentLanguageId) : '';
                const columnSymbol = columnMeasureItem && columnMeasureItem.currencyId ? this.currencies.find((currency) => currency.id === columnMeasureItem.currencyId).symbol : '';
                const lineMeasureItem = this.chartModel.lineMeasures[0];
                const lineMeasureName = lineMeasureItem ? this.categoryMeasurePaths.measurePaths.get(+lineMeasureItem.id).name.get(this.currentLanguageId) : '';
                const lineSymbol = lineMeasureItem && lineMeasureItem.currencyId ? this.currencies.find((currency) => currency.id === lineMeasureItem.currencyId).symbol : '';
                let lineMeasuresValueIndex;
                let columnMeasuresValueIndex;
                if (columnMeasureItem && lineMeasureItem) {
                    columnMeasuresValueIndex = 0;
                    lineMeasuresValueIndex = 1;
                }
                else if (columnMeasureItem) {
                    columnMeasuresValueIndex = 0;
                }
                else {
                    lineMeasuresValueIndex = 0;
                }
                processedChartData.series.forEach((seriesItem) => {
                    processedChartData.seriesItems.push({
                        id: seriesItem.seriesId,
                        name: seriesItem.name
                    });
                    seriesItem.data.forEach((seriesItemData) => {
                        let dataItem = {};
                        dataItem.category = categoryElements.get(seriesItemData.categoryId);
                        dataItem.categoryId = seriesItemData.categoryId;
                        if (columnMeasureItem) {
                            const id = `${seriesItem.seriesId}-${columnMeasureItem.id}`;
                            columnMeasureItem && (dataItem[id] = seriesItemData.value[columnMeasuresValueIndex]);
                            dataItem[`measure${id}`] = {
                                name: columnMeasureName,
                                value: data_formatter_1.formatNumber(seriesItemData.value[columnMeasuresValueIndex], columnSymbol)
                            };
                        }
                        if (lineMeasureItem) {
                            const id = `${seriesItem.seriesId}-${lineMeasureItem.id}`;
                            lineMeasureItem && (dataItem[id] = seriesItemData.value[lineMeasuresValueIndex]);
                            dataItem[`measure${id}`] = {
                                name: lineMeasureName,
                                value: data_formatter_1.formatNumber(seriesItemData.value[lineMeasuresValueIndex], lineSymbol)
                            };
                        }
                        dataItem.seriesId = seriesItem.seriesId;
                        processedChartData.data.push(dataItem);
                    });
                });
            }
            else {
                processedChartData.series.forEach((seriesItem) => {
                    seriesItem.data.forEach((seriesItemData) => {
                        let dataItem = {};
                        dataItem.category = categoryElements.get(seriesItemData.categoryId);
                        dataItem.categoryId = seriesItemData.categoryId;
                        dataItem[seriesItem.measureId] = seriesItemData.value;
                        dataItem.seriesId = seriesItem.measureId;
                        dataItem[`measure${seriesItem.measureId}`] = {
                            name: seriesItem.name,
                            value: data_formatter_1.formatNumber(seriesItemData.value, seriesItem.symbol)
                        };
                        processedChartData.data.push(dataItem);
                    });
                });
            }
        }
        return processedChartData;
    }
    processChartOptions(languageDirection) {
        let categoryPaths = this.categoryMeasurePaths.categoryPaths;
        let measurePaths = this.categoryMeasurePaths.measurePaths;
        const measures = this.chartModel.columnMeasures.concat(this.chartModel.lineMeasures);
        const valueAxisName = measures.map(measure => measurePaths.get(+measure.id).name.get(this.currentLanguageId)).join(' / ');
        let chartControlOptions = {
            chartType: shared_1.ChartType.COMBINATION,
            chartPalette: this._colorPaletteService.getColorPalette(this.chartModel.selectedPaletteId),
            isRTL: languageDirection === idm_crosscutting_concepts_frontend_1.LanguageDirection.RTL,
            isDataLabelsShowed: this.chartModel.isDataLabelsShowed,
            categoryAxisTitle: this.chartModel.categoryAxisTitle.getValue(this.currentLanguageId) || categoryPaths.get(+this.chartModel.category).name.get(this.currentLanguageId),
            valueAxisTitle: this.chartModel.valueAxisTitle.getValue(this.currentLanguageId) || valueAxisName,
            isMeasureAxisZoomSlicerVisible: this.chartModel.isMeasureAxisZoomSlicerVisible,
            isCategoryAxisZoomSlicerVisible: this.chartModel.isCategoryAxisZoomSlicerVisible
        };
        this.chartControlOptions = new shared_1.CategoricalChartControlOptions(chartControlOptions);
    }
    /**
     * Method is called any time, when report model, or dataSet, or language were changed
     * and redraw list
     */
    redrawChart() {
        if (this.isValidState()) {
            this.clearViewState();
            this.isValid = true;
            if (this.isDataLoaded) {
                this.executeChartReport();
            }
            else {
                const categoryMeasurePaths = Observable_1.Observable.from(this._pathService.getPaths(this.dataSetId));
                const currentLanguage = this._currentLanguageProvider.getCurrentLanguage().pipe(operators_1.distinctUntilChanged());
                const rootPathObservable = Observable_1.Observable.from(this._categoryPathService.getRootCategoryPath(this.dataSetId));
                const currencies = skynet_store_currencies_api_1.currencyStoreManager.selectAll(this.store).pipe(operators_1.filter((currencies) => !currencies.isEmpty()));
                const untitledMessage = this.messageService.getMessage(CombinationChartViewComponent_1.UNTITLED_MESSAGE_KEY).pipe(operators_1.distinctUntilChanged());
                const drillDownMessage = this.messageService.getMessage(reporting_controls_common_logic_1.ReportingControlsCommonLogic.DRILL_DOWN_MESSAGE).pipe(operators_1.distinctUntilChanged());
                Observable_1.Observable.combineLatest(categoryMeasurePaths, currentLanguage, rootPathObservable, Observable_1.Observable.from(this._pageNavigationService.getNavigation()), currencies, untitledMessage, drillDownMessage)
                    .pipe(operators_1.takeUntil(this.destroy$))
                    .subscribe((data) => {
                    this.clearViewState();
                    this.isDataLoaded = true;
                    this.categoryMeasurePaths = data[0];
                    this.currentLanguageId = data[1].getId();
                    this.currentLanguage = data[1];
                    this.rootPath = data[2];
                    this.pageNavigationItems = data[3];
                    this.currencies = Array.from(data[4].toList());
                    this.untitledMessage = data[5];
                    this.drillDownMessage = data[6];
                    // initializes widget title the first time
                    this.widgetTitle = this.getWidgetTitle();
                    this.executeChartReport();
                });
            }
        }
        else {
            this.isValid = false;
            this.clearViewState();
        }
    }
    refreshView(filtersMap) {
        if (this.dataSetId) {
            const pageFilter = filtersMap.get(this.dataSetId);
            if (this.pageFilterTreeDto != pageFilter) {
                this.pageFilterTreeDto = pageFilter;
                this.redrawChart();
            }
        }
    }
    clearViewState() {
        this.chartData = null;
        this.chartControlOptions = null;
        this.hasData = false;
    }
    getExportData(exportType) {
        return this.chartControlComponent.getExportedImage()
            .then((exportedChartImage) => {
            let chartViewImage = exportedChartImage.split(',')[1];
            let exportImages = new Map();
            exportImages.set("chartView", chartViewImage);
            return this.exportDataService.buildExportData(exportImages, exportType, this.currentLanguageId, this.chartControlComponent.getExportWidthHeight(), this.widgetTitle);
        });
    }
    processChartTableData() {
        let categoryName = this.categoryMeasurePaths.categoryPaths.get(+this.chartModel.category).name.get(this.currentLanguageId);
        let headers = [];
        headers.push(categoryName);
        if (this.chartData && this.chartData.series) {
            this.chartData.series.forEach((seriesItem) => {
                let itemName = seriesItem.name;
                if (seriesItem.currencyId) {
                    itemName += ` (${this.currencies.find(item => item.id === seriesItem.currencyId).abbreviation})`;
                }
                headers.push(itemName);
            });
        }
        this.exportHeaders = headers;
        let formattedRows = [];
        let rows = [];
        if (this.chartData && this.chartData.categories) {
            let index = 0;
            let lineMeasuresValueIndex;
            let columnMeasuresValueIndex;
            const columnMeasureItem = this.chartModel.columnMeasures[0];
            const lineMeasureItem = this.chartModel.lineMeasures[0];
            if (columnMeasureItem && lineMeasureItem) {
                columnMeasuresValueIndex = 0;
                lineMeasuresValueIndex = 1;
            }
            else if (columnMeasureItem) {
                columnMeasuresValueIndex = 0;
            }
            else {
                lineMeasuresValueIndex = 0;
            }
            this.chartData.categories.forEach((categoryItem, categoryIndex) => {
                if (this.chartModel.series) {
                    if (columnMeasureItem) {
                        const columnMeasureName = this.categoryMeasurePaths.measurePaths.get(+columnMeasureItem.id).name.get(this.currentLanguageId);
                        const columnSymbol = columnMeasureItem.currencyId ? this.currencies.find((currency) => currency.id === columnMeasureItem.currencyId).symbol : '';
                        formattedRows[index] = [];
                        formattedRows[index].push(`${categoryItem} / ${columnMeasureName}`);
                        rows[index] = [];
                        rows[index].push(`${categoryItem} / ${columnMeasureName}`);
                        this.chartData.series.forEach((seriesItem) => {
                            formattedRows[index].push(data_formatter_1.formatNumber(seriesItem.data[categoryIndex].value[columnMeasuresValueIndex], columnSymbol));
                            rows[index].push(seriesItem.data[categoryIndex].value[columnMeasuresValueIndex] || 0);
                        });
                        index++;
                    }
                    if (lineMeasureItem) {
                        const lineMeasureName = this.categoryMeasurePaths.measurePaths.get(+lineMeasureItem.id).name.get(this.currentLanguageId);
                        const lineSymbol = lineMeasureItem.currencyId ? this.currencies.find((currency) => currency.id === lineMeasureItem.currencyId).symbol : '';
                        formattedRows[index] = [];
                        formattedRows[index].push(`${categoryItem} / ${lineMeasureName}`);
                        rows[index] = [];
                        rows[index].push(`${categoryItem} / ${lineMeasureName}`);
                        this.chartData.series.forEach((seriesItem) => {
                            formattedRows[index].push(data_formatter_1.formatNumber(seriesItem.data[categoryIndex].value[lineMeasuresValueIndex], lineSymbol));
                            rows[index].push(seriesItem.data[categoryIndex].value[lineMeasuresValueIndex] || 0);
                        });
                        index++;
                    }
                }
                else {
                    formattedRows[categoryIndex] = [];
                    formattedRows[categoryIndex].push(categoryItem);
                    rows[categoryIndex] = [];
                    rows[categoryIndex].push(categoryItem);
                    this.chartData.series.forEach((seriesItem) => {
                        formattedRows[categoryIndex].push(data_formatter_1.formatNumber(seriesItem.data[categoryIndex].value, seriesItem.symbol));
                        rows[categoryIndex].push(seriesItem.data[categoryIndex].value || 0);
                    });
                }
            });
        }
        this.exportRows = rows;
        this.chartTableData = new chart_table_data_1.ChartTableData(headers, formattedRows);
    }
    /**
     * Method create report options, using the received properties and applying rows total getting property.
     * @returns {ReportOptions}
     */
    buildReportOptions() {
        return new idm_reporting_service_client_js_1.ReportOptions(null, this.chartModel.excludeUnspecified, true, null, false);
    }
    /**
     * This method check if chart model available, and report model is valid
     * @returns {CategoricalChartModel|boolean}
     */
    isValidState() {
        return this.chartModel && this.chartModel.validateReport();
    }
    /**
     * These method matched series values to category, for right order
     * @param categoriesMap
     * @param baseSeriesMap
     * @returns {Map<number, any>}
     */
    matchSeriesWithCategories(categoriesMap, baseSeriesMap) {
        let matchedSeriesArray = [];
        categoriesMap.forEach((value, key) => {
            matchedSeriesArray.push({
                value: baseSeriesMap.get(key) || [null, null],
                categoryId: key
            });
        });
        return matchedSeriesArray;
    }
    redraw() {
        this.redrawChart();
    }
};
CombinationChartViewComponent.UNTITLED_MESSAGE_KEY = 'reporting.controls.combination-chart.untitled';
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CombinationChartViewComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CombinationChartViewComponent.prototype, "dataSetId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CombinationChartViewComponent.prototype, "state", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CombinationChartViewComponent.prototype, "isDataTableShowed", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", idm_de_core_frontend_1.Entity)
], CombinationChartViewComponent.prototype, "entity", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CombinationChartViewComponent.prototype, "category", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], CombinationChartViewComponent.prototype, "filters", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], CombinationChartViewComponent.prototype, "isEditMode", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], CombinationChartViewComponent.prototype, "title", null);
__decorate([
    core_1.ViewChild('chartControlComponent'),
    __metadata("design:type", sis_radar_chart_control_component_1.RadarChartControlComponent)
], CombinationChartViewComponent.prototype, "chartControlComponent", void 0);
__decorate([
    core_1.ViewChild('rcChartBarToolbarSection'),
    __metadata("design:type", core_1.ElementRef)
], CombinationChartViewComponent.prototype, "rcChartBarToolbarSection", void 0);
__decorate([
    core_1.ViewChild('rcChartBarToolbarTitle'),
    __metadata("design:type", core_1.ElementRef)
], CombinationChartViewComponent.prototype, "rcChartBarToolbarTitle", void 0);
CombinationChartViewComponent = CombinationChartViewComponent_1 = __decorate([
    core_1.Component({
        
        selector: "combination-chart-view",
        styles: [require('./combination-chart-view.component.css')],
        template: require('./combination-chart-view.component.html'),
    }),
    idm_dynamic_controls_metadata_1.ControlMetadata({
        cellCount: 6,
        groups: [
            {
                identity: "ReportingControls",
                name: "Reporting Controls",
                nameMessageKey: "reporting.controls.group.name",
            },
        ],
        settings: {
            main: combination_chart_builder_component_1.CombinationChartBuilderComponent
        },
        template: `<combination-chart-view [id]="controlId" [state]='%{state}' [dataSetId]='%{datasetId}' [title]='%{title}' [isEditMode]="isSettingsActive" [category]='category' [entity]='entity' [filters]="filters" [isDataTableShowed]="%{isDataTableShowed}"></combination-chart-view>`,
        iconInfo: "combination",
        name: "Combination Chart",
        nameKey: "reporting.controls.combination.chart.widget.label",
        height: 400
    })
    /**
     * This component creates Combination Charts according to passed parameters.
     */
    ,
    __param(14, core_1.Optional()),
    __param(15, core_1.Optional()),
    __metadata("design:paramtypes", [idm_message_language_service_client_js_1.LanguageService,
        idm_session_data_provider_api_js_1.CurrentLanguageProvider,
        idm_reporting_service_client_js_1.ReportingService,
        idm_dataset_service_client_js_1.PathService,
        color_palette_service_1.ColorPaletteService,
        idm_dataset_service_client_js_1.CategoryPathService,
        idm_export_client_js_1.ExportService,
        export_data_proccessing_service_1.ExportDataProcessingService,
        idm_page_service_client_js_1.PageNavigationService,
        store_1.Store,
        idm_message_language_service_client_js_1.MessageService,
        idm_classifier_service_client_js_1.ClassifierService,
        idm_kb_service_client_js_1.KbService,
        router_1.ActivatedRoute,
        idm_dynamic_controls_metadata_1.CommunicationService,
        page_filter_service_1.PageFilterService])
], CombinationChartViewComponent);
exports.CombinationChartViewComponent = CombinationChartViewComponent;
//# sourceMappingURL=combination-chart-view.component.js.map